module.exports = __webpack_public_path__ + "static/img/funny.455750ad.png";